import React from "react";

const WireTransferIcon = (props: any) => {
  const { strokeColor = "var(--color-icon-bright)", ...svgProps } = props;
  return (
    <svg width={20} height={20} fill="none" {...svgProps}>
      <g
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        clipPath="url(#a)"
      >
        <path d="M19.166 13.309a5.829 5.829 0 0 1-5.833 5.833l.875-1.458M.833 6.642A5.83 5.83 0 0 1 6.666.809l-.875 1.458" />
        <path
          strokeMiterlimit={10}
          d="M16.666 9.999A6.663 6.663 0 0 1 10 16.665 6.663 6.663 0 0 1 3.333 10 6.663 6.663 0 0 1 10 3.332a6.671 6.671 0 0 1 6.656 6.159c0 .162.01.324.01.508Z"
        />
        <path d="M7.917 11.457c0 .809.625 1.459 1.392 1.459h1.566c.667 0 1.209-.567 1.209-1.275 0-.758-.334-1.033-.825-1.208L8.75 9.558c-.491-.175-.825-.442-.825-1.209 0-.7.542-1.275 1.209-1.275H10.7c.767 0 1.392.65 1.392 1.459M10 6.25v7.5" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WireTransferIcon;
